import { pprops } from '@frontend/sports/common/core/utils/redux';
import { MediaSetEvent, MediaSetEventId, SetMediaWidgetContextPayload } from '@frontend/sports/grid/media/feature/model';
import { createAction, props } from '@ngrx/store';

export class MediaApiActions {
    private static readonly SET_EVENT = '@media/SET_EVENT';
    private static readonly SET_EVENT_ID = '@media/SET_EVENT_ID';
    private static readonly TOGGLE_PLAYING = '@media/TOGGLE_PLAYING';
    private static readonly SET_MEDIA_WIDGET_CONTEXT = '@media/SET_MEDIA_WIDGET_CONTEXT';

    static readonly togglePlaying = createAction(MediaApiActions.TOGGLE_PLAYING, props<{ value: boolean }>());
    static readonly setMediaWidgetContext = createAction(MediaApiActions.SET_MEDIA_WIDGET_CONTEXT, pprops<SetMediaWidgetContextPayload>());
    static readonly setEvent = createAction(MediaApiActions.SET_EVENT, pprops<MediaSetEvent>());
    static readonly setEventId = createAction(MediaApiActions.SET_EVENT_ID, pprops<MediaSetEventId>());
}
